<template>
  <div class="gray-back">
    <div class="mine-box-title">我的会议培训</div>
    <div class="mine-content">
      <el-tabs v-model="active" @tab-click="onStatusChange">
        <el-tab-pane label="报名中" name="1"></el-tab-pane>
        <el-tab-pane label="报名成功" name="2"></el-tab-pane>
        <el-tab-pane label="全部" name="0"></el-tab-pane>
      </el-tabs>

      <el-table ref="table" :data="list" row-key="id" :show-header="false">
        <el-table-column label="报名会议" fixed="left" prop="title">
          <template scope="scope">
            <p>会议场次：{{ scope.row.saiqu_name }}</p>
            <p>单位：{{ scope.row.danwei }}</p>
            <p>报名费：{{ scope.row.total_price }}</p>
            <p>人数：{{ scope.row.membercount }}</p>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="zhuantai">
          <template scope="scope">
            <el-tag v-if="scope.row.memberstatus == 1">
              联系人信息
            </el-tag>
            <el-tag
                v-else-if="scope.row.memberstatus == 2"
            >
              人员信息
            </el-tag>
            <el-tag
                v-else-if="scope.row.memberstatus == 3"
            >
              等级申报
            </el-tag>
            <el-tag
                v-else-if="scope.row.memberstatus == 4"
            >
              等待付款
            </el-tag>
            <el-tag
                v-else-if="scope.row.memberstatus == 6"
                type="success"
            >
              报名成功
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="riqi">
          <template scope="scope">
            {{ scope.row.create_time_str }}
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="caozuo">
          <template scope="scope">
            <el-button type="primary" size="medium" v-show="scope.row.memberstatus==6&&scope.row.can_kaipiao==1"
                       @click.stop="kaipiao(scope.row)">申请开票
            </el-button>
            <el-button class="look-order" size="medium" @click="goDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination
            background
            @current-change="handleCurrentChange" :current-page="parseInt(row.currentpage)"
            :page-size="params.pageSize" layout="total, prev, pager, next"
            :total="row.total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<style scoped>

</style>

<script>
import Vue from "vue";

import LoginDialog from "@/components/LoginDialog.vue";
import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  DropdownMenu,
  DropdownItem,
  Tab,
  Tabs,
  NoticeBar,
} from "vant";

Vue.use(Cell)
    .use(CellGroup)
    .use(Toast)
    .use(Dialog)
    .use(Icon)
    .use(Tag)
    .use(Button)
    .use(DropdownMenu)
    .use(Tab)
    .use(Tabs)
    .use(DropdownItem);
export default {
  name: "HuiyiApplyList",
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    LoginDialog,
  },
  data: function () {
    return {
      loginShow: false,
      active: '1',
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        pageNo: 1,
        pageSize: 5,
        status: 0,
      },
      homeTop: 0,
      list: [],
      userType: 2,
      row: {}
    };
  },
  mounted() {
    document.title = "会议培训报名记录";

    let that = this;
    // console.log(this.$route.meta)
    if (!this.$route.meta.isBack) {
      // 清空查询条件和数据
      that.list = [];
      that.active = '1';
      that.params.pageNo = 1;
      that.params.status = 0;
      that.loading = true;
      that.finished = false;
      that.getList();

      if (this.$route.query.status) {
        that.active = that.params.status = this.$route.query.status;
        console.log(that.active);
      }
    }
    document.getElementById("app").scrollTop = this.homeTop || 0;
    this.$route.meta.isBack = false;
  },
  destroyed() {
  },
  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val
      this.list = []
      this.getList()
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    sizeChange(e) {
      this.params.pageSize = e;
    },
    currentChange(e) {
      this.params.pageNo = e;
    },
    kaipiao(order) {
      rbLink({
        'name': 'HuiyiApplyFapiao',
        'query': {
          id: order.id
        }
      })
    },
    getList() {
      let that = this;
      that.$api.get(
          "/api/huiyi/applylist",
          that.params,
          (res) => {
            that.loading = false;

            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              let list = that.list.concat(res.data.list);

              that.list = list;
            }

            if (res.data.list.length == 0) {
              that.finished = true;
            }
            that.params.pageNo += 1;
            that.row = res.data
          },
          (res) => {
            console.log("没有登录");
            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {},
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true;
            } else {
              Toast(res.msg);
            }
          }
      );
    },

    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList();
        }, 500);
      }
    },

    // 跳转订单详情
    goDetail(order) {
      switch (order.memberstatus) {
        case 1:
          rbLink({
            name: "HuiyiApplyFormStep1",
            query: {
              id: order.id,
            },
          });
          break;
        case 2:
          rbLink({
            name: "HuiyiApplyFormStep2",
            query: {
              id: order.id,
            },
          });
          break;
        case 3:
          rbLink({
            name: "HuiyiApplyFormStep3",
            query: {
              id: order.id,
            },
          });
          break;

        case 4:
          rbLink({
            name: "HuiyiApplyFormStep5",
            query: {
              id: order.id,
            },
          });
          break;

        case 5:
          rbLink({
            name: "HuiyiApplyFormStep5",
            query: {
              id: order.id,
            },
          });
          break;

        case 6:
          rbLink({
            name: "HuiyiApplyFormSuccess",
            query: {
              id: order.id,
            },
          });
          break;
      }
    },

    action(item, index) {
      this.$router.push({
        name: "QcxjStationApply",
        query: {
          id: item.id,
        },
      });
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },

    onStatusChange(tab) {
      let index = tab.name

      console.log('onStatusChange', index)
      let that = this;
      that.params.status = index;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.status = 0;
      that.getList()
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.onRefresh();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// HuiyiApplyList.vue?1139d738